import React, { Component, Fragment } from 'react';
import URC from 'ui-react-common';
import PropTypes from 'prop-types';

const { SubmitButton } = URC.ui.components.button;
const { Type } = URC.ui.components;

class ContinueButton extends Component {
    render() {
        const { id, onClick, loading, text, showCreditWarning } = this.props;
        return (
            <Fragment>
                <SubmitButton
                    id={id}
                    onClick={onClick}
                    loading={loading}
                    name="continueButton"
                >
                    {text}
                </SubmitButton>
                <br />
                {showCreditWarning && (
                    <Type.BodyFour>Won&#39;t affect your credit score.</Type.BodyFour>
                )}
            </Fragment>
        );
    }
}

ContinueButton.defaultProps = {
    showCreditWarning: false,
    onClick: () => {},
};

ContinueButton.propTypes = {
    id: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    loading: PropTypes.bool.isRequired,
    showCreditWarning: PropTypes.bool,
};

export default ContinueButton;
